"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LiquidityPools = void 0;
const config_1 = require("../config");
const util_1 = require("../util");
const network_1 = require("../utils/network");
class LiquidityPools {
    constructor(params) {
        this.environment = params.environment;
        this.config = params.config;
    }
    async getPoolInformation(tokenAddress, fromChainId, toChainId) {
        if (!tokenAddress || fromChainId === undefined || toChainId === undefined) {
            return (0, util_1.formatMessage)(config_1.RESPONSE_CODES.BAD_REQUEST, "Bad input params. fromChainId, toChainId and tokenAddress are mandatory parameters");
        }
        const queryParamMap = new Map();
        queryParamMap.set("tokenAddress", tokenAddress);
        queryParamMap.set("fromChainId", fromChainId);
        queryParamMap.set("toChainId", toChainId);
        const checkTransferStatusRequest = {
            method: network_1.RequestMethod.GET,
            baseURL: this.config.getHyphenBaseURL(this.environment),
            path: this.config.getPoolInfoPath,
            queryParams: queryParamMap
        };
        const response = await (0, network_1.restAPI)(checkTransferStatusRequest);
        return response;
    }
}
exports.LiquidityPools = LiquidityPools;
